import styled from 'styled-components'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

export const StyledToastContainer = styled(ToastContainer)`
  &.Toastify__toast-container {
    padding: 0;
  }
  .Toastify__toast {
    background: transparent;
    box-shadow: none;
    padding: 0;
    margin: 8px 0;
  }
  .Toastify__toast-body {
    padding: 0;
    margin: 0;
  }
  .Toastify__close-button {
    align-self: flex-start;
  }
`

const variants = {
  success: {
    bg: '#E6F6EC',
    border: '#34A853',
    text: '#1F3B2A',
    iconBg: '#34A853'
  },
  error: {
    bg: '#FDEAEA',
    border: '#D93025',
    text: '#3D1F1E',
    iconBg: '#D93025'
  },
  info: {
    bg: '#E8F1FD',
    border: '#1A73E8',
    text: '#152A3A',
    iconBg: '#1A73E8'
  }
}

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid ${({ $variant }) => variants[$variant].border};
  background: ${({ $variant }) => variants[$variant].bg};
  min-width: 280px;
  max-width: 520px;
`

export const Text = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: ${({ $variant }) => variants[$variant].text};
`

/* Círculo + check puro CSS */
export const IconCircle = styled.span`
  position: relative;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $variant }) => variants[$variant].iconBg};

  /* checkmark */
  &::after {
    content: '';
    position: absolute;
    left: 5px;
    top: 3px;
    width: 6px;
    height: 10px;
    border-right: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(45deg);
  }
`
